
export function addSVGtoSecondaryBtn() {

    let btns    = document.querySelectorAll('.js-button-secondary');
    let svg     = `<svg id=Layer_1 version=1.1 viewBox="0 0 10.5 15.3"xmlns=http://www.w3.org/2000/svg><path class=st0 d=M10.5,7.7l-7.1,7.1c-.8.8-2,.8-2.8,0h0c-.8-.8-.8-2,0-2.8l4.3-4.3L.6,3.4c-.8-.8-.8-2,0-2.8h0c.8-.8,2-.8,2.8,0l7.1,7.1Z /></svg>`;

    btns.forEach((button) => {

        button.insertAdjacentHTML("beforeend", svg);
    });

    return 'addSVGtoSecondaryBtn';
}
